document.addEventListener('DOMContentLoaded', () => {
  const cache = new Map(); // 缓存已请求的商品数据

  const preview = document.createElement('div');
  preview.id = 'nav-product-preview';
  preview.style.cssText = `
    position: fixed;
    display: none;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.12);
    z-index: 9999;
    pointer-events: none;
    width: 160px;
    transition: opacity 0.1s ease;
    opacity: 0;
  `;
  preview.innerHTML = `
    <img id="nav-preview-img" src="" style="width:100%;border-radius:4px;display:block;" />
    <p id="nav-preview-title" style="margin:6px 0 0;font-size:13px;text-align:center;line-height:1.3;"></p>
  `;
  document.body.appendChild(preview);

  const imgEl = document.getElementById('nav-preview-img');
  const titleEl = document.getElementById('nav-preview-title');

  let currentHandle = null;
  let moveFrame = null;

  function showPreview(x, y) {
    preview.style.display = 'block';
    requestAnimationFrame(() => { preview.style.opacity = '1'; });
    updatePosition(x, y);
  }

  function hidePreview() {
    // 立即隐藏，无延迟
    preview.style.opacity = '0';
    preview.style.display = 'none';
    currentHandle = null;
  }

  function updatePosition(x, y) {
    const pw = preview.offsetWidth || 160;
    const ph = preview.offsetHeight || 180;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    let left = x + 16;
    let top = y - ph / 2;
    if (left + pw > vw - 10) left = x - pw - 16;
    if (top < 10) top = 10;
    if (top + ph > vh - 10) top = vh - ph - 10;
    preview.style.left = left + 'px';
    preview.style.top = top + 'px';
  }

  document.querySelectorAll('header a[href*="/products/"]').forEach(link => {
    link.addEventListener('mouseenter', async (e) => {
      const handle = link.href.match(/\/products\/([^?#/]+)/)?.[1];
      if (!handle || handle === currentHandle) return;
      currentHandle = handle;

      // 立即隐藏旧内容
      preview.style.opacity = '0';

      try {
        let product;
        if (cache.has(handle)) {
          product = cache.get(handle);
        } else {
          const res = await fetch(`/products/${handle}.js`);
          product = await res.json();
          cache.set(handle, product);
        }

        // 确认鼠标还在这个链接上
        if (currentHandle !== handle) return;

        // 预加载图片后再显示
        if (product.featured_image) {
          const tempImg = new Image();
          tempImg.onload = () => {
            if (currentHandle !== handle) return;
            imgEl.src = product.featured_image;
            titleEl.textContent = product.title || '';
            showPreview(e.clientX, e.clientY);
          };
          tempImg.src = product.featured_image;
        }
      } catch (err) {
        console.warn('Product preview failed:', err);
      }
    });

    link.addEventListener('mousemove', (e) => {
      if (moveFrame) cancelAnimationFrame(moveFrame);
      moveFrame = requestAnimationFrame(() => updatePosition(e.clientX, e.clientY));
    });

    link.addEventListener('mouseleave', () => {
      hidePreview(); // 立即隐藏
    });
  });
});
